<template lang="pug">
  b-modal#assignPageRole(
  ref="assignPageRole"
  :title="pageId"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  body-class="p-0"
  border
  @ok="done"
  @cancel="cancel"
  @shown="shown")
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit" style="overflow: hidden scroll; height: 30vh;").p-0.m-0.xps
      b-list-group(flush)
        b-list-group-item(
          v-for="pageRoleInfo in pageRoleList"
          :data="pageRoleInfo"
          :key="pageRoleInfo.role_id"
          v-if="!loading"
          ).d-flex.flex-nowrap.px-3.py-2
          label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
            input.switch-input(type="checkbox" v-model="selectedRoles" :value="pageRoleInfo.role_id")
            span.switch-slider(:data-checked='$t("ui.on")' :data-unchecked='$t("ui.off")')
          div.ml-3.align-self-center {{ pageRoleInfo.role_name }}
    div.row
      div.col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";

export default {
  components: {
    SubmitButton
  },
  props: {
    pageId: "",
    pageName: ""
  },
  data() {
    return {
      pageRoleList: [],
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      selectedRoles: []
    };
  },
  methods: {
    getPageRoleList: function() {
      this.loading = true;
      this.selectedRoles = [];
      let url = config.pageRoleListUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.role,
        target_page_id: this.pageId
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              this.feedback.success = (typeof response.data.status == "string") ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.pageRoleList = response.data.tbl_page_role_list;
                this.loading = false;

                for (var i = 0; i < this.pageRoleList.length; i++) {
                  if (this.pageRoleList[i].allow == 1) {
                    this.selectedRoles.push(this.pageRoleList[i].role_id);
                  }
                }
              } else {
                // this.$helpers.handleFeedback(this.feedback.status);
                this.$emit("failed", "assign_roles", this.feedback.status);
                this.$refs.assignPageRole.hide();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.system"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.system"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    done: function(evt) {
      evt.preventDefault();

      if (this.selectedRoles.length <= 0) {
        this.feedback.success = false;
        this.feedback.status = this.$t("targetRoleIdRequired");
        return;
      }

      this.setPageRole();
    },
    shown: function() {
      this.getPageRoleList();
    },
    setPageRole: function() {
      let url = config.editPageRoleUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.role,
        target_role_id: this.selectedRoles.toString(),
        target_page_id: this.pageId
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              this.feedback.success = (typeof response.data.status == "string") ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$emit("clicked");
                this.$refs.assignPageRole.hide();
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
                this.$emit("failed", "assign_roles", this.feedback.status);
                this.$refs.assignPageRole.hide();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.system"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.system"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    cancel: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    }
  }
};
</script>
